import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import hmacHelper from "./HmacHelper.ts";
import { getExternalBaseUrl, EXTERNAL_CONFIG } from "./ExternalConfig.ts";

class TemplateExternalService {
  private readonly api: AxiosInstance;
  private readonly clientId = EXTERNAL_CONFIG.clientId;
  private readonly clientSecret = EXTERNAL_CONFIG.clientSecret;
  private readonly contextPath = EXTERNAL_CONFIG.services.template;
  private readonly dropContextPath = EXTERNAL_CONFIG.dropContextPath;

  constructor() {
    this.api = axios.create({
      baseURL: getExternalBaseUrl()
    });

    this.api.interceptors.request.use((config) => this.signRequest(config));
  }

  private signRequest(config: InternalAxiosRequestConfig) {
    console.log("Signing external template request...");
    if (!config.url?.includes("/ext/")) return config;

    console.log("config url: ", config.url);
    console.log("config base url: ", config.baseURL);

    const url = new URL(config.url!, config.baseURL).toString();

    console.log("External url: ", url);

    const method = (config.method || "get").toUpperCase();
    const body = config.data || {};

    const hmacHeaders = hmacHelper.generateHmacHeaders(
      method,
      url,
      body,
      this.clientId,
      this.clientSecret,
      this.contextPath,
      this.dropContextPath
    );

    console.log("hmacHeaders: ", hmacHeaders);

    Object.entries(hmacHeaders).forEach(([key, value]) => {
      config.headers.set?.(key, value);
    });

    return config;
  }

  public getApplicationCreatedEmailTemplate() {
    return this.api.get(
      "/template-service/ext/templates/APPLICATION_CREATED_EMAIL"
    );
  }
}

export default new TemplateExternalService();

